webpackJsonp([10],{

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  apiData: {
    roles: [],
    proyectos: [],
    proyectos_keys: [],
    partes: []
  },
  loaded: false,
  pendientes: {
    proyectos: 0
  },
  online: true,
  page: {
    title: ''
  },
  generalAlert: {
    type: 'danger',
    title: '',
    message: '',
    icon: '',
    show: false
  },
  jsonStatic: {},
  version: '1.0.10'
});

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
	TOGGLE_LOADING: function TOGGLE_LOADING(state) {
		state.callingAPI = !state.callingAPI;
	},
	TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
		state.searching = state.searching === '' ? 'loading' : '';
	},
	SET_USER: function SET_USER(state, user) {
		state.user = user;
	},
	SET_TOKEN: function SET_TOKEN(state, token) {
		state.token = token;
	},
	ADD_API_DATA: function ADD_API_DATA(state, payload) {
		state.apiData[payload.type].push(payload.item);
	},
	CLEAR_API_DATA: function CLEAR_API_DATA(state, type) {
		if (type === '*') {
			for (var key in state.apiData) {
				state.apiData[key] = [];
			}
		} else {
			state.apiData[type] = [];
		}
	},
	SYNC_API_DATA: function SYNC_API_DATA(state, payload) {
		if (payload.items) {
			state.apiData[payload.type] = payload.items;
		}
	},
	SYNC_PENDIENTES: function SYNC_PENDIENTES(state, asset) {
		state.pendientes[asset] = state.pendientes[asset] === 0 ? 1 : 0;
	},
	SYNC_ONLINE: function SYNC_ONLINE(state, value) {
		state.online = value;
	},
	SET_PAGE_TITLE: function SET_PAGE_TITLE(state, value) {
		state.page.title = value;
	},
	SHOW_DANGER_ALERT: function SHOW_DANGER_ALERT(state, alert) {
		state.generalAlert.title = alert.title;
		state.generalAlert.message = alert.message;
		state.generalAlert.type = 'danger';
		state.generalAlert.icon = 'ban';
		state.generalAlert.show = true;
	},
	SHOW_SUCCESS_ALERT: function SHOW_SUCCESS_ALERT(state, alert) {
		state.generalAlert.title = alert.title;
		state.generalAlert.message = alert.message;
		state.generalAlert.type = 'success';
		state.generalAlert.icon = 'check';
		state.generalAlert.show = true;
	},
	HIDE_GENERAL_ALERT: function HIDE_GENERAL_ALERT(state) {
		state.generalAlert.title = '';
		state.generalAlert.message = '';
		state.generalAlert.type = '';
		state.generalAlert.icon = '';
		state.generalAlert.show = false;
	},
	DATA_LOADED: function DATA_LOADED(state) {
		state.loaded = true;
	},
	SET_JSON_STATIC: function SET_JSON_STATIC(state, json) {
		state.jsonStatic = json;
	}
});

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  hayApiDataCargada: function hayApiDataCargada(state) {
    return function (key) {
      return state.apiData[key].length > 0;
    };
  },
  hayProyectosCargados: function hayProyectosCargados(state) {
    return function () {
      return state.apiData.proyectos.length > 0;
    };
  },
  getProyectoPorCodigo: function getProyectoPorCodigo(state) {
    return function (codigo) {
      for (var i = 0; i < state.apiData.proyectos.length; i++) {
        if (state.apiData.proyectos[i].codigo_proyecto === codigo) {
          return state.apiData.proyectos[i];
        }
      }
      return null;
    };
  },
  getProyectosUsuario: function getProyectosUsuario(state) {
    return function (queryString) {
      var result = state.user.proyectos ? state.user.proyectos : [];
      if (!queryString) {
        return result;
      } else {
        var aResult = [];
        for (var i = 0; i < result.length; i++) {
          aResult.push('_id=' + result[i]);
        }
        return aResult.join('&');
      }
    };
  },
  getNombreRolPorCodigo: function getNombreRolPorCodigo(state) {
    return function (codigo) {
      if (state.apiData.roles && state.apiData.roles[codigo]) {
        return state.apiData.roles[codigo].name;
      }
      return codigo;
    };
  },
  getTipoRolPorCodigo: function getTipoRolPorCodigo(state) {
    return function (codigo) {
      if (state.apiData.roles && state.apiData.roles[codigo]) {
        return state.apiData.roles[codigo].type;
      }
      return false;
    };
  }
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Template_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_local_storage__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);



// import LoginView from './components/Login.vue'
// import DashboardView from './components/views/Dashboard.vue'







var LoginView = function LoginView() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 199));
};
var DashboardView = function DashboardView() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 200));
};
var ProyectoInfoView = function ProyectoInfoView() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 201));
};
var ProyectoLinkView = function ProyectoLinkView() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 202));
};
var ProyectoIframeView = function ProyectoIframeView() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 203));
};
var ProyectoRMView = function ProyectoRMView() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 204));
};
var ProyectoComprasView = function ProyectoComprasView() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 205));
};
var ProyectoParteDiarioView = function ProyectoParteDiarioView() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 206));
};
var Error404View = function Error404View() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 207));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

// Routes
var routes = [{
  path: '/login',
  component: LoginView,
  meta: { description: 'Login', requiresGuest: true }
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Template_vue__["a" /* default */],
  children: [{
    path: 'dashboard',
    alias: '',
    component: DashboardView,
    name: 'dashboard',
    meta: { description: 'Movimientos de mercaderia', requiresAuth: true }
  }, {
    path: 'proyecto/:codigo_proyecto/info',
    alias: 'Info',
    component: ProyectoInfoView,
    name: 'proyecto_info',
    meta: { description: 'Informacion', requiresAuth: true },
    props: true
  }, {
    path: 'proyecto/:codigo_proyecto/link',
    alias: 'Link',
    component: ProyectoLinkView,
    name: 'proyecto_link',
    meta: { description: 'Link', requiresAuth: true },
    props: true
  }, {
    path: 'proyecto/:codigo_proyecto/iframe/:index',
    alias: 'Iframe',
    component: ProyectoIframeView,
    name: 'proyecto_iframe',
    meta: { description: 'Iframe', requiresAuth: true },
    props: true
  }, {
    path: 'proyecto/:codigo_proyecto/reportes-media',
    alias: 'Reportes',
    component: ProyectoRMView,
    name: 'proyecto_rm',
    meta: { description: 'Reportes & Media', requiresAuth: true },
    props: true
  }, {
    path: 'proyecto/:codigo_proyecto/compras',
    alias: 'Compras',
    component: ProyectoComprasView,
    name: 'compras',
    meta: { description: 'Compras', requiresAuth: true },
    props: true
  }, {
    path: 'proyecto/:codigo_proyecto/parte-diario',
    alias: 'Parte Diario',
    component: ProyectoParteDiarioView,
    name: 'parte_diario',
    meta: { description: 'Compras', requiresAuth: true },
    props: true
  }, {
    path: 'mis-compras/:tabla',
    alias: 'MisCompras',
    component: ProyectoComprasView,
    name: 'mis_compras',
    meta: { description: 'Mis compras', requiresAuth: true },
    props: true
  }, {
    path: 'formularios/parte-diario',
    alias: 'Parte Diario',
    component: ProyectoParteDiarioView,
    name: 'parte_diario',
    meta: { description: 'Compras', requiresAuth: true }
  }]
}, {
  // not found handler
  path: '*',
  component: Error404View
}];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: routes,
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('HIDE_GENERAL_ALERT');

  if (to.meta.requiresAuth) {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user || __WEBPACK_IMPORTED_MODULE_5__core_local_storage__["a" /* default */].getToken()) {
      if (window.innerWidth < 768) {
        __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__["a" /* EventBus */].$emit('COLAPSAR MENU');
      }
      next();
    } else {
      next({
        path: '/login'
      });
    }
  }
  if (to.meta.requiresGuest) {
    if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.user || __WEBPACK_IMPORTED_MODULE_5__core_local_storage__["a" /* default */].getToken()) {
      next({ name: 'dashboard' });
    } else {
      next();
    }
  }
});

Object(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], router);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Template_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc1d51b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Template_vue__ = __webpack_require__(183);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc1d51b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66790218_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(172);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66790218_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMenu_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44641b52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMenu_vue__ = __webpack_require__(171);
function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44641b52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.proyectos.length > 0)?_c('ul',{staticClass:"sidebar-menu"},[_c('li',{staticClass:"header"}),_vm._v(" "),_c('li',{staticClass:"treeview"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},_vm._l((_vm.proyectos),function(item){return _c('li',{staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-folder"}),_vm._v(" "),_c('span',{staticClass:"menu-cod-proy"},[_vm._v(_vm._s(item.codigo_proyecto))])]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu subitems"},[_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/proyecto/' + item.codigo_proyecto + '/info'}},[_c('a',[_c('i',{staticClass:"far fa-info-circle"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v("Informacion")])])]),_vm._v(" "),_vm._l((item.simaapplink),function(link,index){return [(link.tipo === 'iframe')?_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/proyecto/' + item.codigo_proyecto + '/iframe/' + index}},[_c('a',[_c('i',{staticClass:"far fa-code"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v(_vm._s(link.cta_text ? link.cta_text : '-Sin nombre-'))])])]):_c('li',{staticClass:"pageLink"},[_c('a',{attrs:{"href":link.cta_link_or_iframe_src,"target":"_blank"}},[_c('i',{staticClass:"fa fa-external-link-alt"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v(_vm._s(link.cta_text))])])])]}),_vm._v(" "),_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/proyecto/' + item.codigo_proyecto + '/reportes-media'}},[_c('a',[_c('i',{staticClass:"far fa-chart-pie"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v("Reportes & Media")])])]),_vm._v(" "),_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/proyecto/' + item.codigo_proyecto + '/compras'}},[_c('a',[_c('i',{staticClass:"fa fa-shopping-basket"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v("Compras")])])])],2)])}))]),_vm._v(" "),_c('li',{staticClass:"treeview"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"treeview-menu subitems"},[_c('li',{staticClass:"treeview"},[_c('router-link',{attrs:{"tag":"a","to":'/mis-compras/enprogreso'}},[_c('i',{staticClass:"far fa-sync"}),_vm._v(" "),_c('span',[_vm._v("En Progreso")])]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu subitems"},[_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/mis-compras/solicitados'}},[_c('a',[_c('i',{staticClass:"fa fa-minus"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v("Solicitados")])])]),_vm._v(" "),_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/mis-compras/aprobados'}},[_c('a',[_c('i',{staticClass:"fa fa-minus"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v("Aprobados")])])]),_vm._v(" "),_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/mis-compras/comprados'}},[_c('a',[_c('i',{staticClass:"fa fa-minus"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v("Comprados")])])])],1)],1),_vm._v(" "),_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/mis-compras/completado'}},[_c('a',[_c('i',{staticClass:"far fa-check-circle"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v("Completados")])])]),_vm._v(" "),_c('router-link',{staticClass:"pageLink",attrs:{"tag":"li","to":'/mis-compras/archivo'}},[_c('a',[_c('i',{staticClass:"far fa-archive"}),_vm._v(" "),_c('span',{staticClass:"page"},[_vm._v("Archivados")])])])],1)])]):_vm._e(),_vm._v(" "),(_vm.proyectos.length == 0)?_c('ul',{staticClass:"sidebar-menu"},[_c('li',{staticClass:"header",staticStyle:{"color":"#fff"}},[_vm._v("Sin proyectos asignados")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-archive"}),_vm._v(" "),_c('span',[_vm._v("Proyectos")]),_vm._v(" "),_c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left fa-fw pull-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-shopping-basket"}),_vm._v(" "),_c('span',[_vm._v("Mis Compras")]),_vm._v(" "),_c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left fa-fw pull-right"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"main-sidebar"},[_c('section',{staticClass:"sidebar"},[_c('div',{staticClass:"user-panel"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pull-left info"},[_c('div',[_c('p',{staticClass:"white username",domProps:{"innerHTML":_vm._s(_vm.displayName)}})]),_vm._v(" "),(this.$store.state.online)?_c('a',{attrs:{"href":"javascript:;","id":"status"}},[_c('i',{staticClass:"fa fa-circle text-success"}),_vm._v(" Online\n        ")]):_vm._e(),_vm._v(" "),(!this.$store.state.online)?_c('a',{attrs:{"href":"javascript:;","id":"status"}},[_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Offline\n        ")]):_vm._e()])]),_vm._v(" "),_c('sidebar-menu'),_vm._v(" "),_c('div',{attrs:{"id":"version-app"}},[_vm._v("\n      V"+_vm._s(_vm.$store.state.version)+"\n    ")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-left image"},[_c('i',{staticClass:"fas fa-user"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return login; });
var login = '/auth/local';

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wrapper', _vm.classes]},[_c('header',{staticClass:"main-header"},[_c('span',{staticClass:"logo-mini text-center"},[_c('router-link',{staticClass:"pageLink",attrs:{"tag":"a","to":'/'}},[_c('img',{staticClass:"img-responsive center-block logo",attrs:{"src":"/static/img/logo_sima_100.png","alt":"Logo"}}),_vm._v(" "),_c('span',{staticClass:"brand"},[_vm._v(" SIMA")])])],1),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-static-top text-center",attrs:{"role":"navigation"}},[_vm._m(0),_vm._v(" "),_c('router-link',{staticStyle:{"position":"absolute","width":"100%","left":"0","height":"1px"},attrs:{"tag":"a","to":'/'}},[_c('img',{staticClass:"img-responsive logo-mobile",attrs:{"src":"/static/img/logo_sima_100.png","alt":"Logo"}})]),_vm._v(" "),_c('div',{staticClass:"navbar-custom-menu"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"dropdown user user-menu"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:;","data-toggle":"dropdown"},on:{"click":function($event){_vm.logout()}}},[_c('i',{staticClass:"fas fa-sign-out-alt"}),_vm._v(" "),_c('span',[_vm._v("Salir")])])])])])],1)]),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[(_vm.$store.state.page.title)?_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.$store.state.page.title)+"\n      ")])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"content",class:{'fullh':_vm.$route.name === 'proyecto_iframe' || _vm.$route.name === 'dashboard'}},[(_vm.generalAlert.show)?_c('div',{staticClass:"alert alert-dismissible general-alert",class:'alert-' + _vm.generalAlert.type},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-hidden":"true"},on:{"click":function($event){_vm.closeGeneralAlert()}}},[_vm._v(" x ")]),_vm._v(" "),(_vm.generalAlert.title)?_c('h4',[_c('i',{staticClass:"icon fa fa-ban",class:'fa-' + _vm.generalAlert.icon}),_vm._v(_vm._s(_vm.generalAlert.title))]):_vm._e(),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.generalAlert.message)}})]):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1),_vm._v(" "),_c('footer',{staticClass:"main-footer"},[_c('strong',[_vm._v("Copyright © "+_vm._s(_vm.year)+" - v11")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sidebar-toggle",attrs:{"href":"javascript:;","data-toggle":"offcanvas","role":"button","id":"btn-menu"}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba3757b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba3757b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BounceLoader_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7cecb436_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BounceLoader_vue__ = __webpack_require__(193);
function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BounceLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7cecb436_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BounceLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-bounce v-bounce1",style:(_vm.spinnerBasicStyle)},[_c('div',{staticClass:"v-bounce v-bounce2",style:(_vm.spinnerStyle)}),_c('div',{staticClass:"v-bounce v-bounce3",style:(_vm.spinnerStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(44);


/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  setToken: function setToken(token) {
    if (window.localStorage) {
      window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_jwt_token', token);
    }
  },
  getToken: function getToken() {
    if (window.localStorage) {
      return window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_jwt_token');
    }
    return false;
  },
  removeToken: function removeToken() {
    if (window.localStorage) {
      window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_jwt_token');
    }
  },

  /* USERS */
  setUser: function setUser(user) {
    if (window.localStorage) {
      window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(user));
    }
  },
  getUser: function getUser() {
    if (window.localStorage) {
      return JSON.parse(window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_user'));
    }
    return null;
  },
  removeUser: function removeUser() {
    if (window.localStorage) {
      window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_user');
    }
  },

  /* GENERAL */
  setKey: function setKey(key, item) {
    if (window.localStorage) {
      var data = (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' || typeof item === 'array' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item) : item;
      window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_' + key, data);
    }
  },
  getKey: function getKey(key, is_object) {
    if (window.localStorage) {
      var data = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_' + key);
      return is_object ? JSON.parse(data) : data;
    }
    return null;
  },
  removeKey: function removeKey(key) {
    if (window.localStorage) {
      window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].appName + '_' + key);
    }
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(121);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */]
}));

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  appName: 'simaapp',
  apiEndpoint: 'https://data.sima-api.com',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_local_storage__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(174);







/* harmony default export */ __webpack_exports__["a"] = ({
  request: function request(method, uri) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var auth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var headers = {};

    if (!method) {
      console.error('API function call requires method argument');
      return;
    }

    if (!uri) {
      console.error('API function call requires uri argument');
      return;
    }

    if (auth && __WEBPACK_IMPORTED_MODULE_4__core_local_storage__["a" /* default */].getToken()) {
      headers.authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__core_local_storage__["a" /* default */].getToken();
    }

    var _uri = uri[uri.length - 1] === '/' ? uri.substring(0, uri.length - 1) : uri;
    var url = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].apiEndpoint + _uri;

    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: method, url: url, data: data, headers: headers });
  },
  login: function login(data) {
    return this.request('POST', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* login */], data).then(function (result) {
      return result.data;
    });
  },
  store: function store(uri, data, auth) {
    var method = data.id > 0 ? 'PUT' : 'POST';
    var _uri = data.id > 0 ? uri.concat(data.id) : uri[uri.length - 1] === '/' ? uri.substring(0, uri.length - 1) : uri;
    return this.request(method, _uri, data, auth);
  },
  post: function post(uri, data, auth) {
    return this.request('POST', uri, data, auth).then(function (result) {
      return result.data;
    });
  },
  delete: function _delete(uri, data, auth) {
    var method = 'DELETE';
    uri = data && data.id && data.id > 0 ? uri.concat(data.id) : uri;

    return this.request(method, uri, data, auth);
  },
  get: function get(uri, auth) {
    return this.request('GET', uri, null, auth).then(function (result) {
      return result.data;
    });
  },
  getJsonStatico: function getJsonStatico() {
    // let method = 'GET'
    var uri = './static/json/static.json';
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(uri);
  },

  // SIMA API
  getProyectos: function getProyectos() {
    var uri = '/simaappproyectos';
    switch (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.role.name) {
      case 'Administrator':
      case 'Auditor':
        break;
      default:
        var queryString = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getProyectosUsuario(true);
        if (queryString.length > 0) {
          uri = uri.concat('?').concat(queryString);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve([]);
        }
        break;
    }
    return this.request('GET', uri, null, true).then(function (result) {
      return result.data;
    });
  },
  getRoles: function getRoles() {
    return this.request('GET', '/users-permissions/roles', null, true).then(function (result) {
      var data = {};

      result.data.roles.forEach(function (role) {
        data[role.id] = {
          id: role.id,
          name: role.name,
          type: role.type
        };
      });

      __WEBPACK_IMPORTED_MODULE_4__core_local_storage__["a" /* default */].setKey('roles', data);
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SYNC_API_DATA', {
        type: 'roles',
        items: data
      });
      return result.data;
    });
  },
  getProyectoInfo: function getProyectoInfo(codigo) {
    var vm = this;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      vm.request('GET', '/simaappproyectos?codigo_proyecto=' + codigo, null, true).then(function (result) {
        if (result.data.length > 0) {
          resolve(result.data[0]);
        } else {
          reject(new Error('No se encontró la información solicitada'));
        }
      });
    });
  },
  getProyectoLink: function getProyectoLink(codigo, tipo) {
    var vm = this;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      vm.request('GET', '/simaapplinks?codigo_proyecto=' + codigo + '&tipo=' + tipo, null, true).then(function (result) {
        if (result.data.length > 0) {
          resolve(result.data);
        } else {
          reject(new Error('No se encontró la información solicitada'));
        }
      });
    });
  },
  getReportes: function getReportes(queryString) {
    var vm = this;
    return vm.getTotalRegistros('simaappreportes', queryString).then(function (total) {
      var _total = total;
      return vm.request('GET', '/simaappreportes?' + queryString, null, true).then(function (result) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
          data: result.data,
          total: _total
        });
      }, function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  saveReportes: function saveReportes(data) {
    var vm = this;
    var method = data._id ? 'PUT' : 'POST';
    var url = '/simaappreportes' + (data._id ? '/' + data._id : '');
    return vm.request(method, url, data, true).then(function (result) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getPartesDiarios: function getPartesDiarios(queryString) {
    var vm = this;
    return vm.getTotalRegistros('simaappformpartediarios', queryString).then(function (total) {
      var _total = total;
      return vm.request('GET', '/simaappformpartediarios?' + queryString, null, true).then(function (result) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
          data: result.data,
          total: _total
        });
      }, function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getModeloParteDiario: function getModeloParteDiario() {
    var vm = this;
    return vm.request('GET', '/content-type-builder/models/simaappformpartediario', null, true).then(function (result) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data.model);
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  savePartesDiarios: function savePartesDiarios(data) {
    var vm = this;
    var method = data._id ? 'PUT' : 'POST';
    var url = '/simaappformpartediarios' + (data._id ? '/' + data._id : '');
    return vm.request(method, url, data, true).then(function (result) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getCompras: function getCompras(queryString) {
    var vm = this;
    return vm.getTotalRegistros('simaappcompras', queryString).then(function (total) {
      var _total = total;
      return vm.request('GET', '/simaappcompras?' + queryString, null, true).then(function (result) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
          data: result.data,
          total: _total
        });
      }, function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  saveCompras: function saveCompras(data) {
    var vm = this;
    var method = data._id ? 'PUT' : 'POST';
    var url = '/simaappcompras' + (data._id ? '/' + data._id : '');
    return vm.request(method, url, data, true).then(function (result) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  getTotalRegistros: function getTotalRegistros(coleccion, queryString) {
    var vm = this;
    return vm.request('GET', '/' + coleccion + '/count?' + queryString, null, true).then(function (result) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
    }, function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  enviarEmail: function enviarEmail(data) {
    // let vm = this
    var header = {};
    var method = 'POST';
    var url = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.jsonStatic.emails.url;

    data.sourceEmail = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.jsonStatic.emails.sourceEmail;
    data.replyToAddresses = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.jsonStatic.emails.replyToAddresses;
    data.bodyCharset = 'UTF-8';
    data.subjectCharset = 'UTF-8';

    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: method, url: url, data: data, header: header });
  }
});

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pouchdb__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pouchdb_find__ = __webpack_require__(179);



__WEBPACK_IMPORTED_MODULE_1_pouchdb__["a" /* default */].plugin(__WEBPACK_IMPORTED_MODULE_2_pouchdb_find__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  db: null,
  init: function init(dbName) {
    var promises = [];
    this.db = new __WEBPACK_IMPORTED_MODULE_1_pouchdb__["a" /* default */](dbName);

    promises.push(this.db.createIndex({
      index: { fields: ['asset', 'codigo_proyecto', 'action', 'archivado'] }
    }));
    promises.push(this.db.createIndex({
      index: { fields: ['asset', 'codigo_proyecto', 'archivar', 'completado', 'solicitado_user'] }
    }));
    promises.push(this.db.createIndex({
      index: { fields: ['sync_api'] }
    }));

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
  },
  save: function save(item, asset, action) {
    item.asset = asset;
    item.sync_api = true;
    item.action = item.action ? item.action : action;
    delete item.__v;

    if (action === 'create' && !item._id) {
      item._id = Date.now().toString();
    }

    return this.db.put(item);
  },
  findByIds: function findByIds(ids, asset) {
    return this.db.find({
      selector: { id: { $in: ids }, asset: asset
        /* sort: [{id: 'asc'}] */
      } });
  },
  findByFilters: function findByFilters(asset, filters) {
    var _selector = {
      asset: asset
    };

    if (filters.codigo_proyecto) {
      _selector.codigo_proyecto = filters.codigo_proyecto;
    }

    if (filters.solicitado_user) {
      _selector.solicitado_user = filters.solicitado_user;
    }

    if (filters.archivado) {
      _selector.archivado = filters.archivado;
    }

    if (filters.action) {
      _selector.action = filters.action;
    }

    if (filters.archivar === true || filters.archivar === false) {
      _selector.archivar = filters.archivar;
    }

    if (filters.completado === true || filters.completado === false) {
      _selector.completado = filters.completado;
    }

    return this.db.find({
      selector: _selector
      /* sort: [{id: 'asc'}] */
    });
  },
  getById: function getById(id) {
    return this.db.get(id);
  },
  getAllToSync: function getAllToSync() {
    return this.db.find({
      selector: { sync_api: true }
    });
  },
  remove: function remove(item) {
    return this.db.remove(item);
  }

});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_local_storage__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sidebar__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hideseek__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_hideseek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_pouchdb__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
//import faker from 'faker'











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Template',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_6__Sidebar__["a" /* default */]
  },
  data: function data() {
    return {
      proyectos: [],
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hideLogoOnMobile
      },
      error: '',
      estaSincronizando: false,
      onlineState: this.isNetworkOnline()
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['user', 'generalAlert'])),
  created: function created() {
    var _this = this;

    var vm = this;
    this.$on('online', function () {
      this.onlineState = true;
    });
    this.$on('offline', function () {
      this.onlineState = false;
    });

    __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__["a" /* EventBus */].$on('enviar-email-compras', function (compra, accion) {
      vm.enviarEmails(compra, accion);
    });

    __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__["a" /* EventBus */].$on('COLAPSAR MENU', function () {
      var btnMenu = document.getElementById('btn-menu');
      var body = document.getElementsByTagName('BODY');
      if (document.body.classList.contains('sidebar-open')) {
        btnMenu.click();
      }
    });
    this.interval = setInterval(function () {
      return _this.isNetworkOnline();
    }, 7000);
  },
  mounted: function mounted() {
    this.getData();
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__["a" /* EventBus */].$off('enviar-email-compras');
  },

  methods: {
    closeGeneralAlert: function closeGeneralAlert() {
      this.$store.commit('HIDE_GENERAL_ALERT');
    },
    getData: function getData(regenerate) {
      var _this2 = this;

      var vm = this;
      var promises = [];

      if (regenerate || !this.$store.getters.hayApiDataCargada('roles')) {
        promises.push(__WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].getRoles());
      }

      if (regenerate || !this.$store.getters.hayApiDataCargada('proyectos')) {
        promises.push(vm.getProyectos());
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (values) {
        _this2.$store.commit('DATA_LOADED');
        __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__["a" /* EventBus */].$emit('datos-cargados');
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__["a" /* EventBus */].$emit('error-carga');
      });
    },
    getProyectos: function getProyectos() {
      var vm = this;
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].getProyectos().then(function (data) {
        var _keys = [];
        var _data = [];

        vm.$store.commit('CLEAR_API_DATA', 'proyectos');

        data.forEach(function (item) {
          if (item['Activo']) {
            _data.push(item);
            _keys.push(item.codigo_proyecto);
          }
        });

        vm.$store.commit('SYNC_API_DATA', {
          type: 'proyectos',
          items: _data
        });

        vm.$store.commit('SYNC_API_DATA', {
          type: 'proyectos_keys',
          items: _keys
        });

        return _data;
      });
    },
    isNetworkOnline: function isNetworkOnline() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://images.sima-api.com/image-handler/img/sima-api/favicon-16x16.png?timestamp=' + new Date().getTime()).then(function (response) {
        vm.$store.commit('SYNC_ONLINE', true);
        if (!vm.estaSincronizando) {
          vm.syncAPI();
        }
      }).catch(function (error) {
        vm.$store.commit('SYNC_ONLINE', false);
      });
    },
    syncAPI: function syncAPI() {
      var vm = this;
      var _api = [];
      var toast = null;

      _api['parte_diario'] = '/simaappformpartediarios';
      _api['reporte_media'] = '/simaappreportes';
      _api['compras'] = '/simaappcompras';

      __WEBPACK_IMPORTED_MODULE_10__core_pouchdb__["a" /* default */].getAllToSync().then(function (response) {
        if (response.docs.length > 0) {
          var promises = [];

          vm.estaSincronizando = true;
          vm.$toasted.show("Sincronizando datos. Por favor espere.", {
            icon: 'sync',
            theme: "primary",
            position: "top-center"
          });

          var _loop = function _loop(i) {

            var id = response.docs[i]._id.toString();
            var asset = response.docs[i].asset.toString();
            switch (response.docs[i].action) {
              case 'create':
                promises.push(vm.addAPI(response.docs[i], _api).then(function (resp) {
                  if (response.docs[i].asset === 'compras' && typeof response.docs[i].accion_email !== 'undefined') {
                    var accion = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.clone(response.docs[i].accion_email);
                    delete response.docs[i].accion_email;
                    vm.enviarEmails(response.docs[i], accion);
                  }
                  vm.removeFromLocalDB(id);
                }));
                break;
              case 'edit':
                promises.push(vm.editAPI(response.docs[i], _api).then(function () {
                  if (response.docs[i].asset === 'compras' && typeof response.docs[i].accion_email !== 'undefined') {
                    var accion = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.clone(response.docs[i].accion_email);
                    delete response.docs[i].accion_email;
                    vm.enviarEmails(response.docs[i], accion);
                  }
                  vm.removeFromLocalDB(id);
                }));
                break;
            }
          };

          for (var i = 0; i < response.docs.length; i++) {
            _loop(i);
          }
          if (promises.length > 0) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (values) {
              __WEBPACK_IMPORTED_MODULE_4__core_event_bus_js__["a" /* EventBus */].$emit('sync-completed');
              vm.estaSincronizando = false;
              vm.$toasted.clear();
            });
          } else {
            vm.estaSincronizando = false;
            vm.$toasted.clear();
          }
        } else {
          vm.estaSincronizando = false;
        }
      });
    },
    addAPI: function addAPI(item, _api) {
      var tipo = item.asset;

      delete item._id;
      // delete item.asset

      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].request('POST', _api[tipo], item, true);
    },
    editAPI: function editAPI(item, _api) {
      var id = item._id;
      var tipo = item.asset;

      delete item._id;
      // delete item.asset;

      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].request('PUT', _api[tipo] + '/' + id, item, true);
    },
    removeFromLocalDB: function removeFromLocalDB(id) {
      __WEBPACK_IMPORTED_MODULE_10__core_pouchdb__["a" /* default */].getById(id).then(function (doc) {
        return __WEBPACK_IMPORTED_MODULE_10__core_pouchdb__["a" /* default */].remove(doc);
      }).catch(function (error) {
        alert('Error en removeFromLocalDB: ' + error);
      });
    },
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    },
    enviarEmails: function enviarEmails(compra, accion) {
      var vm = this;
      var to = [];
      var cc = [];

      var usuariosPorRoles = vm.getUsuariosPorRoles(compra.codigo_proyecto);
      var mensajes = this.$store.state.jsonStatic.compras.mensajes;
      var subjects = this.$store.state.jsonStatic.compras.subjects;

      switch (accion) {
        case 'Pendiente':
          to = vm.getEmailsPorRoles(usuariosPorRoles, ['manager']);
          cc = vm.getEmailsPorRoles(usuariosPorRoles, ['jefe_de_obras', 'coordinador']);
          break;
        case 'Aprobado':
          to = vm.getEmailsPorRoles(usuariosPorRoles, ['compras']);
          // cc = vm.getEmailsPorRoles(usuariosPorRoles, ['jefe_de_obras', 'coordinador'])
          break;
        case 'Rechazado':
          to = vm.getEmailsPorRoles(usuariosPorRoles, ['manager']);
          cc = vm.getEmailsPorRoles(usuariosPorRoles, ['supervisor', 'empleado', 'jefe_de_obras', 'coordinador']);
          break;
        case 'Comprado':
          to = vm.getEmailsPorRoles(usuariosPorRoles, ['manager']);
          cc = vm.getEmailsPorRoles(usuariosPorRoles, ['supervisor', 'empleado', 'jefe_de_obras', 'coordinador']);
          break;
        case 'Completado':
          to = vm.getEmailsPorRoles(usuariosPorRoles, ['compras']);
          cc = vm.getEmailsPorRoles(usuariosPorRoles, ['jefe_de_obras', 'coordinador', 'manager']);
          break;
      }

      var subject = '[{codigo_proyecto}] {pedido_id} - {subject_estado}';
      var mensaje = mensajes[accion] + '\n\n' + 'Detalle del Pedido: \n\n' + '- # Pedido: {pedido_id} \n' + '- Proyecto: {codigo_proyecto} \n' + '- Estado: {estado} \n' + '- Item: {item_descripcion} - {qty} {unidad_medida} \n' + '- Solicitado por: {solicitado_user} \n' + '- Validado por: {validado_user} \n' + '- Comprado por: {comprado_user} \n' + '- # Orden de Compra: {id_orden_compra}';

      mensaje = mensaje.replace('{pedido_id}', compra.pedido_id).replace('{codigo_proyecto}', compra.codigo_proyecto).replace('{estado}', compra.estado).replace('{item_descripcion}', compra.item_descripcion ? compra.item_descripcion : '').replace('{qty}', compra.qty ? compra.qty : '').replace('{unidad_medida}', compra.unidad_medida ? compra.unidad_medida : '').replace('{solicitado_user}', compra.solicitado_user ? compra.solicitado_user : '').replace('{validado_user}', compra.validado_user ? compra.validado_user : '').replace('{comprado_user}', compra.comprado_user ? compra.comprado_user : '').replace('{id_orden_compra}', compra.id_orden_compra ? compra.id_orden_compra : '');

      subject = subject.replace('{codigo_proyecto}', compra.codigo_proyecto).replace('{pedido_id}', compra.pedido_id).replace('{subject_estado}', subjects[accion]);

      console.debug(mensaje);

      if (to.length > 0) {
        __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].enviarEmail({
          'toEmailAddresses': to,
          'ccEmailAddresses': cc,
          'bodyData': mensaje,
          'subjectdata': subject
        }).then(function (resp) {
          console.debug(resp);
        });
      }
    },
    getUsuariosPorRoles: function getUsuariosPorRoles(codigoProyecto) {
      var vm = this;
      var proyecto = vm.$store.getters.getProyectoPorCodigo(codigoProyecto);
      var salida = {};

      if (proyecto) {
        for (var i = 0; i < proyecto.usuarios.length; i++) {
          var usuario = proyecto.usuarios[i];
          if (usuario.email) {
            var tipoRol = vm.$store.getters.getTipoRolPorCodigo(usuario.role);
            if (typeof salida[tipoRol] === 'undefined') {
              salida[tipoRol] = [];
            }
            salida[tipoRol].push(usuario);
          }
        }
      }

      return salida;
    },
    getEmailsPorRoles: function getEmailsPorRoles(usuarios, roles) {
      var salida = [];

      for (var i = 0; i < roles.length; i++) {
        if (typeof usuarios[roles[i]] !== 'undefined') {
          for (var j = 0; j < usuarios[roles[i]].length; j++) {
            salida.push(usuarios[roles[i]][j].email);
          }
        }
      }

      return salida;
    },
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);
      __WEBPACK_IMPORTED_MODULE_5__core_local_storage__["a" /* default */].removeUser();
      __WEBPACK_IMPORTED_MODULE_5__core_local_storage__["a" /* default */].removeToken();
      document.body.classList.remove('sidebar-open');
      this.$router.push('/login');
    }
  }
});
window.addEventListener("beforeunload", confirm);
function confirm(e) {
  var confirmationMessage = "Se perderán los datos no sincronizados. ¿Desea continuar?";
  e.returnValue = confirmationMessage;
  return confirmationMessage;
}

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarMenu__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Sidebar',
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_1__SidebarMenu__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['user', 'generalAlert']), {
    displayName: function displayName() {
      return this.user ? this.user.nombre + ' ' + this.user.apellido + '<br>' + this.user.email : null;
    }
  }),
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SidebarMenu',
  computed: {
    proyectos: function proyectos() {
      return this.$store.state.apiData.proyectos;
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(52);
//
//
//
//
//
//

// import staticJson from '../static/json/static.json'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      section: 'Head',
      staticJson: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getJsonStatico().then(function (resp) {
      console.debug(resp.data);
      _this.staticJson = resp.data;
      _this.$store.commit('SET_JSON_STATIC', resp.data);
    });
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'BounceLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '60px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        borderRadius: this.radius,
        opacity: 0.6,
        position: 'absolute',
        top: 0,
        left: 0
      }
    };
  },

  computed: {
    spinnerBasicStyle: function spinnerBasicStyle() {
      return {
        height: this.size,
        width: this.size,
        position: 'relative'
      };
    }
  }

});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_local_storage__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toasted__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_googlemaps_dist_vue_googlemaps_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_googlemaps_dist_vue_googlemaps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_googlemaps_dist_vue_googlemaps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_BounceLoader_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vee_validate__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_es__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_pouchdb__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_offline__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_offline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_offline__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










// import {capitalize, toQueryString, labelCase, prettyBytes} from './filters'





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_toasted___default.a, {
  iconPack: 'fontawesome'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('bounce-loader', __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_BounceLoader_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vee_validate__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_10_vee_validate__["a" /* Validator */].localize('es', __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_es___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_offline___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('SET_USER', __WEBPACK_IMPORTED_MODULE_5__core_local_storage__["a" /* default */].getUser());
__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('SYNC_API_DATA', { type: 'roles', items: __WEBPACK_IMPORTED_MODULE_5__core_local_storage__["a" /* default */].getKey('roles', true) });

__WEBPACK_IMPORTED_MODULE_12__core_pouchdb__["a" /* default */].init('simaapp-web');

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#root',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */]);
  }
});

/***/ })

},[96]);


// WEBPACK FOOTER //
// static/js/app.930e73b0c6df43d51056.js